import { useContext, useEffect, useState } from 'react';

import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
import Button from 'components/button';
import LogoIcon from './icons/LogoIcon';
import { KeycloakContext } from './Secured';
import { useAppContext } from 'AppContext';

const CustomPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 8,
  maxWidth: 800,
  maxHeight: 'calc(100% - 16px)',
  margin: 8,
  [theme.breakpoints.up('sm')]: {
    margin: 32,
    maxHeight: 'calc(100% - 64px)',
  },
}));

export const WelcomeDialog = () => {
  const keycloakCtx = useContext(KeycloakContext);
  const isProducer = keycloakCtx.keycloak.hasResourceRole('producer');

  const { loadingProductsSummary, allProductCount } = useAppContext();

  const showWelcomeMessage = isProducer && localStorage.getItem('welcomeMessageShown') !== 'true';

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    localStorage.setItem('welcomeMessageShown', 'true');
    setOpen(false);
  };

  useEffect(() => {
    if (showWelcomeMessage && !loadingProductsSummary && !allProductCount) {
      setOpen(true);
    }
  }, [showWelcomeMessage, loadingProductsSummary, allProductCount]);

  return (
    <Dialog open={open} PaperComponent={CustomPaper}>
      <DialogContent style={{ padding: 0 }}>
        <Box sx={{ padding: { xs: '24px 16px 0 16px', md: '24px 40px 0 40px' } }}>
          <Box display="flex" justifyContent="center" mb={3}>
            <LogoIcon />
          </Box>
          <Box fontWeight={700} fontSize={34} textAlign="center">
            Välkommen!
          </Box>
          <Box mb={1} fontWeight={700} textAlign="center">
            Vi är glada att ha dig med oss! Sygrid är byggt för att göra det så enkelt som möjligt för dig som
            leverantör att digitalisera dina produkter – snabbt, korrekt och utan krångel.
          </Box>
          <Box border="1px solid rgba(0, 0, 0, 0.2)" borderRadius={12} p={2.5}>
            <Box mb={2}>
              <Box fontWeight={700}>✨ Testa Bild → Produkt</Box>
              <Box>
                Ta bilder på din produktetikett och förpackning – vi fyller automatiskt i produktinformation åt dig,
                inklusive kategori, ingredienser, näringsvärden, allergener och mycket mer.
              </Box>
            </Box>
            <Box mb={2}>
              <Box fontWeight={700}>🛠 Vi hjälper dig på vägen</Box>
              <Box>
                Vi visar bara de fält som är relevanta för din produktkategori, flaggar allergener i realtid och
                validerar EAN-koder automatiskt – allt för att hjälpa dig skapa korrekta produkter med minsta möjliga
                ansträngning.
              </Box>
            </Box>
            <Box mb={2}>
              <Box fontWeight={700}>📦 Vill du digitalisera i bulk?</Box>
              <Box>
                Inga problem! Ladda upp ett kalkylblad med din produktdata, koppla kolumner och vi tar hand om resten –
                inklusive koppling av bilder.
              </Box>
            </Box>
            <Box mb={2}>
              <Box fontWeight={700}>✅ Kvalitetssäkrat av experter</Box>
              <Box>
                Alla produkter går genom vår produktgranskning där experter ser till att allt följer lagkrav innan de
                godkänns för export.
              </Box>
            </Box>
            <Box mb={2}>
              <Box>
                Behöver du hjälp eller har frågor? Kontakta oss på{' '}
                <a href="mailto:support@sygrid.com" style={{ textDecoration: 'none' }}>
                  support@sygrid.com
                </a>{' '}
                så hjälper vi dig gärna.
              </Box>
            </Box>
            <Box>Vänliga hälsningar,</Box>
            <Box fontWeight={700}>Teamet på Sygrid</Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" gridGap={16} px={{ xs: 1, md: 4 }} pb={2}>
          <Button size="small" variant="contained" color="primary" onClick={handleClose}>
            Kom igång!
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeDialog;
